import { memo } from 'react';

const DefaultPage = memo(() => null);

export default DefaultPage;
